module.exports = __webpack_public_path__ + "static/media/cp15.b06f06fb.pdf";